import styled from "styled-components";

const ToolsButtons = styled.div`
  display: grid;
  gap: 16px;
`;

export default ToolsButtons;
